import {
  FETCH_PROMOTIONS_DATA,
  FETCH_PROMOTIONS_SUCCESS,
  FETCH_PROMOTIONS_FAILURE,
  FETCH_PROMOTIONS_EDIT_DATA,
  FETCH_PROMOTIONS_EDIT_SUCCESS,
  FETCH_PROMOTIONS_EDIT_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
  edit: {
    loading: false,
    data: null,
    error: null,
  },
};

const Promotions = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROMOTIONS_DATA:
      return { ...state, loading: true, error: null };
    case FETCH_PROMOTIONS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_PROMOTIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case FETCH_PROMOTIONS_EDIT_DATA:
      return { ...state, edit: { loading: true, data: null, error: null } };
    case FETCH_PROMOTIONS_EDIT_SUCCESS:
      return { ...state, edit: { loading: false, data: action.payload, error: null } };
    case FETCH_PROMOTIONS_EDIT_FAILURE:
      return { ...state, edit: { loading: false, data: null, error: action.payload } };

    default:
      return state;
  }
};

export default Promotions;
